<script lang="ts">
  import { beforeNavigate } from "$app/navigation"
	import { applyAction, enhance } from '$app/forms';
	import { currentAppUser, pocketbase } from '$lib/pocketbase';
  import { RiArrowDropDownLine, RiQuestionFill } from "svelte-remixicon"
  import Page from "$lib/layouts/page.svelte"
	import { page } from '$app/stores';
  import { slide } from "svelte/transition"
  import Password from "$lib/components/form-elements/password.svelte"
	import Logout from '$lib/components/pocketbase/logout.svelte';
  import { languagePreference, localeStrings } from "$lib/i18n"
  import { colorOptions } from "$lib/utils.js"

	export let form;

  // const emailRegex = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@[*[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+]*/

  // let email = ""

  let help = ""
  let onPage = true

  $: showId = $page.url.searchParams.get("show") || "gpt-111"
  
  $: s = $localeStrings
	$: {
		if (form !== null) form = JSON.parse(form);
	}

  const setHelp = (string) => help = string

	let randomColor = colorOptions[Math.floor(Math.random() * colorOptions.length)]
	let loading = false;

  beforeNavigate(() => onPage = false)
</script>

{#if onPage}
  <Page title="{s.register}" showHelp>
    {#if !$currentAppUser}
      <form
        method="POST"
        class="max-w-screen-sm"
        use:enhance={() => {
          loading = true;
          return async ({ result }) => {
            pocketbase.authStore.loadFromCookie(document.cookie);
            await applyAction(result);
            loading = false
          };
        }}
      >
      <input type="hidden" name="color" value={randomColor} />
      <input type="hidden" name="role" value="user" />
      
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="form-group form-group-ai" on:click={() => setHelp("language_preference")}>
        <!-- LANG -->
        <label for="language_preference">{s.language} <span class="help"><RiQuestionFill class="inline" /></span></label>
        <div transition:slide class="instructions mb-2">
          {s.help_language}
        </div>
        <div class="relative">
          <div class="absolute right-0 text-white pointer-events-none h-full flex flex-col justify-center px-1">
            <RiArrowDropDownLine class="w-8 h-8" />
          </div>
          <select on:focus={() => setHelp("language_preference")} bind:value={$languagePreference} class="form-field-ai w-full" id="language_preference" name="language_preference">
            <option value="de">Deutsch</option>
            <option value="en">English</option>
            <option value="de_en">Lieber Deutsch, English OK</option>
            <option value="en_de">English please, Deutsch geht auch</option>
          </select>
        </div>
        {#if form?.response.data.language_preference}
          <p class="my-2 text-red-400">
            {form?.response.data.language_preference.message}
          </p>
        {/if}
      </div>

      <!-- USERNAME -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="form-group form-group-ai" on:click={() => setHelp("username")}>
        <!-- LANG -->
        <label for="username">{s.username} <span class="help"><RiQuestionFill class="inline" /></span></label>
        {#if help === "username"}
          <div transition:slide class="instructions">
            {s.help_username}
          </div>
        {/if}
    
        <input on:focus={() => setHelp("username")} type="text" name="username" placeholder="{s.username}" class="form-field-ai" />

        {#if form?.response.data.username}
          <p class="my-2 text-red-400">
            {form?.response.data.username.message}
          </p>
        {/if}
      </div>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="form-group form-group-ai" on:click={() => setHelp("email")}>
        <!-- LANG -->
        <label for="email">{s.email} <span class="help"><RiQuestionFill class="inline" /></span></label>
        {#if help === "email"}
          <div transition:slide class="instructions">
            {s.help_email}
          </div>
        {/if}
    
          <input on:focus={() => setHelp("email")} type="email" name="email" placeholder="Email" class="form-field-ai" />
          {#if form?.response.data.email}
            <p class="my-2 text-red-400">
              {form?.response.data.email.message}
            </p>
          {/if}
        </div>
        <!--  -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="form-group form-group-ai" on:click={() => setHelp("password")}>
        <!-- LANG -->
        <label for="password">{s.password} <span class="help"><RiQuestionFill class="inline" /></span></label>
        {#if help === "password"}
          <div transition:slide class="instructions">
            {s.help_password}
          </div>
        {/if}
    
        <Password on:focus={() => setHelp("password")} value="" name="password" placeholder="Password" />
    
          {#if form?.response.data.password}
            <p class="my-2 text-red-400">
              {form?.response.data.password.message}.<br>
              {s.additional_password}
            </p>
          {/if}
        </div>
        <!--  -->
        <div class="form-group form-group-ai">
          <label for="passwordConfirm">Confirm password</label>
          <Password value="" name="passwordConfirm" placeholder="Confirm Password" />
    
          {#if form?.response.data.passwordConfirm}
            <p class="my-2 text-red-400">
              {form?.response.data.passwordConfirm.message}
            </p>
          {/if}
        </div>

        <p class="w-full text-center mb-4">
          {s.has_account} <a class="underline" data-sveltekit-reload href="/auth/login" type="submit"> {s.log_in} </a>
        </p>
        <!--  -->
        <div class="form-group form-group-ai text-white">
          <div class="flex justify-between mr-3">
            <p class="block">{s.newsletter}</p> <div class="w-6 h-6"><input class="block w-full h-full accent-welcome-ai" type="checkbox" name="accepts_marketing" /></div>
          </div>
        </div>
        <div class="form-group form-group-ai">
          <input type="submit" value={loading ? 'Loading' : 'Register'} class="btn-ai" />
        </div>
    
        <!-- {#if $page.status !== 200}
          <div class="form-group form-group-ai text-red-400">
            {$page.status}: {form?.response?.message}
          </div>
        {/if} -->
      </form>
    {:else}
      <div class="p-8">
        <Logout />
      </div>
    {/if}
  </Page>
{/if}

<style>

  label .help {
    opacity: 0;
    transition: 0.1s opacity;
  }

  label:hover .help {
    opacity: 1;
  }
</style>
